<div class="flex flex-col w-full h-full">
    <button class="absolute right-0 mr-32 mt-4" (click)="goBack()" matTooltip="Regresar">
        <mat-icon class="icon-size-1 text-slate-200" [svgIcon]="'feather:arrow-left-circle'"></mat-icon>
    </button>
    <iframe [src]="reporteUrl | safeUrl" width="100%" height="100%"></iframe>
</div>